import { render, staticRenderFns } from "./SymbolTrades.vue?vue&type=template&id=f110f49a&scoped=true"
import script from "./SymbolTrades.vue?vue&type=script&lang=js"
export * from "./SymbolTrades.vue?vue&type=script&lang=js"
import style0 from "./SymbolTrades.vue?vue&type=style&index=0&id=f110f49a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f110f49a",
  null
  
)

export default component.exports